import React, { useState } from 'react'
import { Form, message, Modal, Row, Space } from 'antd'
import { LocationSignUp } from '../../../components/LocationSignUp'
import { ButtonEx } from '../../HeroLocations/index.style'
import { useDeepEffect } from '../../../utils/hooks'
import _, { isEmpty } from 'lodash'
import axios from 'axios'
import { RESPONSE_MESSAGE } from '../../../utils/constants'

const AddLocation = ({ setFormData, setPage, formData, heroType }) => {
  const [locations, setLocations] = useState([])

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      if (formData.address) {
        const location = {
          lat: formData.lat || '',
          lng: formData.lng || '',
          radius: formData.radius || '',
          address: formData.address || ''
        }

        setLocations([location])
      }
    }
  }, [formData])

  const heroConfig = {
    radius: 5000,
    locationCount: 1
  }

  const handleSetLocations = async (location) => {
    await setLocations((prevState) => {
      prevState.splice(1, 0, location)
      return [...prevState]
    })
  }

  const handleSetDeleteLocations = async (id) => {
    await setLocations((prevState) => {
      prevState.splice(id, 1)
      return [...prevState]
    })

    await localStorage.removeItem('location-data')
  }

  const onBack = () => {
    setPage('1')
  }

  const onFinish = async () => {
    const location = locations[0]
    if (heroType !== 'FACTORY') {
      const data = {
        ...formData,
        lat: location.lat,
        lng: location.lng,
        radius: location.radius,
        address: location.address
      }

      await setFormData(data)
      await setPage('3')
    } else {
      const data = {
        hero: {
          email: formData.email,
          heroName: formData.name,
          heroType: heroType,
          lineId: formData.lineId,
          password: formData.password,
          province: formData.province,
          tel: formData.tel,
          plateLicense: formData.plateLicense || '',
          purpose: formData.purpose || '',
          postalAddress: formData.postalAddress || ''
        },
        location: {
          id: 0,
          lat: location.lat,
          lng: location.lng,
          radius: location.radius,
          address: location.address
        },
        heroMaterialRequests: []
      }

      try {
        const token = localStorage.getItem('user-token')
        await axios.post(
          process.env.REACT_APP_API_ENDPOINT + `/hero/create`,
          data,
          {
            headers: {
              Authorization: !_.isNull(token) ? `${token}` : ''
            }
          }
        )
        message.success(RESPONSE_MESSAGE.SUCCESS)
        setPage('4')
      } catch (err) {
        const { response } = err
        const { data } = response
        Modal.error({
          content: `${data.message}`
        })
      }
    }
  }

  return (
    <Form onFinish={onFinish} layout="vertical">
      <LocationSignUp
        locations={locations}
        heroConfig={heroConfig}
        handleSetLocations={handleSetLocations}
        handleSetDeleteLocations={handleSetDeleteLocations}
      />
      <Row justify="center" style={{ marginTop: 15 }}>
        <Space>
          <ButtonEx color="#707070" type="primary" onClick={() => onBack()}>
            ย้อนกลับ
          </ButtonEx>
          <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
            ต่อไป
          </ButtonEx>
        </Space>
      </Row>
    </Form>
  )
}

export default AddLocation



// WEBPACK FOOTER //
// ./src/pages/Signup/AddLocation/index.js